import { render, staticRenderFns } from "./UpdatingCampaignDetailsModal.vue?vue&type=template&id=bb665564&scoped=true&"
import script from "./UpdatingCampaignDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./UpdatingCampaignDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatingCampaignDetailsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UpdatingCampaignDetailsModal.vue?vue&type=style&index=1&id=bb665564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb665564",
  null
  
)

export default component.exports